import React, { useRef, useEffect, FocusEvent, MouseEvent } from "react";
import { CheckboxStates, CheckboxStatesTypes, UUID } from "src/common";

type AllProps = {
  className?: string;
  selected: CheckboxStatesTypes;
  value: unknown; // NOTE: Pass the id or value representing this checkbox
  onChange: (e: FocusEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean
}

function CheckBox(props: AllProps) {
  const { onChange, label, selected, className, disabled } = props;
  const checkbox_ref = useRef<HTMLInputElement>(null);
  // NOTE: Stable random Id for the checkbox (computed once at mount). Used to associate the <label htmlFor> with the <input id>.
  const uuid_ref = useRef(new UUID().String());

  useEffect(() => {
    if (!!checkbox_ref.current) {
      if (selected === CheckboxStates.checked) {
        checkbox_ref.current.checked = true;
        checkbox_ref.current.indeterminate = false;
      } else if (selected === CheckboxStates.empty) {
        checkbox_ref.current.checked = false;
        checkbox_ref.current.indeterminate = false;
      } else if (selected === CheckboxStates.indeterminate) {
        checkbox_ref.current.checked = false;
        checkbox_ref.current.indeterminate = true;
      }
    }
  }, [selected]);

  return <div
    onClick={(e: MouseEvent<HTMLInputElement>) => { e.stopPropagation(); }}
    className={`form-check ${!!className ? className : ""}`}>
    <input type="checkbox"
      ref={checkbox_ref}
      id={uuid_ref.current}
      className="form-check-input"
      onChange={onChange}
      disabled={disabled} />
    <label aria-label={!!label ? label : "Select"}
      htmlFor={uuid_ref.current}
      className="form-check-label">{!!label ? label : ""}</label>
  </div >;

}

export default React.memo(CheckBox);